import Axios from "axios";
import { openLayerFn } from "../../views/Layout";
import {
  AppContext,
  SocketCommand,
  socketManager,
} from "../../components/AppProvider";

const axios = Axios.create();

axios.interceptors.request.use(
  (req) => {
    // console.log("req req", req);
    return req;
  },
  (err) => {
    // console.log("req err", err);
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  (req) => {
    // console.log("res req", req);
    const protocolId = req?.data?.protocolId;
    const resultMsg = req?.data?.resultMsg;
    if (protocolId === "999" && resultMsg === "error") {
      // console.log("로그아웃처리");
      const { dispatch } = useContext(AppContext);

      openLayerFn($(".alert-layer-logout"));
      // dispatch({ type: LOG_OUT_SUCCESS });
      // socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
      //   login: "out",
      //   userToken: "",
      // });
    }

    return req;
  },
  (err) => {
    // console.log("req err", err);
    return Promise.reject(err);
  }
);

export default axios;

